(function () {
  'use strict';

  var IMAGE_EXT = /\.(jpe?g|png|webp)$/i;
  var IMAGE_MIME = /^(image\/jpeg|image\/png|image\/webp)$/i;
  var PDF_EXT = /\.pdf$/i;
  var PDF_MIME = /^application\/pdf$/i;

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function trim(val) {
    return String(val || '').trim();
  }

  function isEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trim(val));
  }

  function isChecked(form, name) {
    var el = form.elements[name];
    return !!(el && el.checked);
  }

  function setFeedback(form, type, message) {
    var box = qs(form, '[data-b2b-feedback]');
    if (!box) return;
    box.hidden = false;
    box.className =
      'b2b-application-form__feedback b2b-application-form__feedback--' + type;
    box.textContent = message;
    box.setAttribute('role', type === 'error' ? 'alert' : 'status');
    box.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');
    box.setAttribute('tabindex', '-1');
    box.focus({ preventScroll: true });
  }

  function clearFeedback(form) {
    var box = qs(form, '[data-b2b-feedback]');
    if (!box) return;
    box.hidden = true;
    box.textContent = '';
    box.className = 'b2b-application-form__feedback';
    box.removeAttribute('role');
    box.removeAttribute('aria-live');
  }

  function isSuccessPayload(payload) {
    if (!payload || typeof payload !== 'object') return false;
    if (payload.success === true || payload.success === 'true') return true;
    if (payload.ok === true || payload.ok === 'true') return true;
    return false;
  }

  function validateFile(input, kind) {
    if (!input || !input.files || !input.files[0]) {
      return kind === 'image'
        ? 'Storefront image is required.'
        : 'Resale certificate PDF is required.';
    }

    var file = input.files[0];
    var name = file.name || '';
    var type = file.type || '';

    if (kind === 'image') {
      if (!IMAGE_EXT.test(name) || !IMAGE_MIME.test(type)) {
        return 'Storefront image must be JPG, PNG, or WEBP.';
      }
    }

    if (kind === 'pdf') {
      if (!PDF_EXT.test(name) || !PDF_MIME.test(type)) {
        return 'Resale certificate must be a PDF.';
      }
    }

    return '';
  }

  function validateForm(form) {
    var requiredFields = [
      ['business_name', 'Business name is required.'],
      ['first_name', 'Contact first name is required.'],
      ['last_name', 'Contact last name is required.'],
      ['email', 'Email is required.'],
      ['phone', 'Phone number is required.'],
      ['address', 'Business address is required.'],
      ['city', 'City is required.'],
      ['state', 'State is required.'],
      ['zip', 'Zip code is required.'],
      ['country', 'Country is required.'],
      ['website_url', 'Website or social media URL is required.'],
      ['storefront_description', 'Storefront presence description is required.'],
    ];

    var i;
    for (i = 0; i < requiredFields.length; i += 1) {
      var name = requiredFields[i][0];
      var message = requiredFields[i][1];
      var el = form.elements[name];
      if (!el || !trim(el.value)) return message;
    }

    if (!isEmail(form.elements.email.value)) {
      return 'Please enter a valid email address.';
    }

    var imageError = validateFile(qs(form, '[data-b2b-file="image"]'), 'image');
    if (imageError) return imageError;

    var pdfError = validateFile(qs(form, '[data-b2b-file="pdf"]'), 'pdf');
    if (pdfError) return pdfError;

    if (!isChecked(form, 'agree_lead_time')) {
      return 'Lead time agreement is required.';
    }
    if (!isChecked(form, 'agree_storage')) {
      return 'Storage condition agreement is required.';
    }
    if (!isChecked(form, 'agree_shelf_life')) {
      return 'Shelf life agreement is required.';
    }
    if (!isChecked(form, 'agree_b2b_terms')) {
      return 'B2B terms agreement is required.';
    }

    return '';
  }

  function setSubmitting(form, submitting) {
    var btn = qs(form, 'button[type="submit"]');
    if (btn) {
      if (submitting) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
    if (submitting) {
      form.dataset.submitting = 'true';
    } else {
      delete form.dataset.submitting;
    }
  }

  /** Theme may set aria-busy on click; reset after all handlers finish. */
  function resetSubmitButton(form) {
    setSubmitting(form, false);
    window.setTimeout(function () {
      setSubmitting(form, false);
    }, 0);
  }

  function buildFormData(form) {
    var data = new FormData(form);
    ['agree_lead_time', 'agree_storage', 'agree_shelf_life', 'agree_b2b_terms'].forEach(function (name) {
      data.set(name, isChecked(form, name) ? '1' : '');
    });
    return data;
  }

  function parseJsonResponse(res, form) {
    return res.text().then(function (text) {
      if (!text) {
        return { ok: res.ok, payload: null, parseError: !res.ok };
      }
      try {
        return { ok: res.ok, payload: JSON.parse(text), parseError: false };
      } catch (e) {
        return { ok: res.ok, payload: null, parseError: true };
      }
    });
  }

  function initForm(form) {
    if (!form || form.dataset.b2bBound === 'true') return;
    form.dataset.b2bBound = 'true';

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        clearFeedback(form);

        if (form.dataset.submitting === 'true') return;

        var endpoint = trim(form.dataset.endpoint);
        if (!endpoint) {
          setFeedback(form, 'error', form.dataset.errorMessage || 'Form endpoint is not configured.');
          resetSubmitButton(form);
          return;
        }

        var validationError = validateForm(form);
        if (validationError) {
          setFeedback(form, 'error', validationError);
          resetSubmitButton(form);
          return;
        }

        setSubmitting(form, true);

        fetch(endpoint, {
          method: 'POST',
          body: buildFormData(form),
          credentials: 'omit',
        })
          .then(function (res) {
            return parseJsonResponse(res, form);
          })
          .then(function (result) {
            if (result.ok && isSuccessPayload(result.payload)) {
              setFeedback(
                form,
                'success',
                (result.payload && result.payload.message) ||
                  form.dataset.successMessage ||
                  'Application submitted.',
              );
              form.reset();
              return;
            }

            if (result.parseError && result.ok) {
              setFeedback(
                form,
                'error',
                'Your application may have been received, but we could not confirm success in the browser. If you do not receive a follow-up email, please contact Support@Silkygem.com.',
              );
              return;
            }

            var message =
              (result.payload && result.payload.message) ||
              form.dataset.errorMessage ||
              'Submission failed.';
            setFeedback(form, 'error', message);
          })
          .catch(function () {
            setFeedback(
              form,
              'error',
              'Unable to confirm your submission from the browser (network or security settings). If you do not receive a follow-up email, please contact Support@Silkygem.com.',
            );
          })
          .finally(function () {
            resetSubmitButton(form);
          });
      },
      true,
    );
  }

  function init() {
    qsa(document, '[data-b2b-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    qsa(event.target, '[data-b2b-form]').forEach(initForm);
  });
})();
